import { api } from "@api/api";
import { Session } from "@lib/types/session";

const getAvailabilityWithID = async (availabilityID: string) => {
  const { data } = await api.post<Session>("/getAvailabilityWithID", { availabilityID });
  return data;
};

export default getAvailabilityWithID;
